module.exports = __webpack_public_path__ + "static/cbam-works-2-ba9e4bdb8e8e537806af2be81b840fb7.png";